<template>
    <div>
        <div class="group-list-wrap" v-if="showGroupList && status===1">
            <div class="group-list-head">
                <div>
                    <img src="https://m1.tuniucdn.com/fb2/t1/G4/M00/F6/E1/Cii-VVy1aoCIVf6aAAABlJvM1igAAFQ3AP__lQAAAGs650_w640_h0_c0_t0.png" class="group-list-img" />
                    <span class="group-list-text text-num">{{groupingPersonNum}}人<span class="text-desc">正发起拼团，你可以直接参与</span></span>
                </div>
                <div>
                    <span class="show-more" @click="showMore">查看更多</span>
                    <img src="https://m.tuniucdn.com/fb2/t1/G5/M00/22/01/Cii-tFy1ad-IEah1AAAAlv9u8MQAAVJXgP__u4AAAES972_w640_h0_c0_t0.png" class="arrow-right">
                </div>
            </div>
            <div class="group-list-body">
                <div>
                    <swipe :auto="5000" :speed="700" :showIndicators="false" :vertical="true" :enableDrag="false" :style="{height: swiperHeight}" v-if="pendingListShow.length > 1">
                        <swipe-item v-for="outter in pendingListShow" :key="outter">
                            <div v-for="(inner, innerIndex) in outter" class="group-detail-wrap">
                                <div class="group-detail" :class="{'top-border': innerIndex > 0}">
                                    <div class="group-detail-left">
                                        <img :src="inner.organiserHeadImg" class="detail-img">
                                        <div class="detail-desc">
                                            <span class="desc-text">{{inner.organiserNickname}}的团 只差<span class="text-num">{{inner.remainPersonNum}}</span>人</span>
                                            <span class="desc-countdown">距结束仅剩 {{inner.remainTimeFormat}}</span>
                                        </div>
                                    </div>
                                    <div class="group-detail-right" @click="joinGroup(inner.groupId)">去参团</div>
                                </div>
                            </div>
                        </swipe-item>
                    </swipe>
                    <div :style="{height: swiperHeight}" v-else>
                        <div v-for="(inner, innerIndex) in pendingListShow[0]" class="group-detail-wrap">
                            <div class="group-detail" :class="{'top-border': innerIndex > 0}">
                                <div class="group-detail-left">
                                    <img :src="inner.organiserHeadImg" class="detail-img">
                                    <div class="detail-desc">
                                        <span class="desc-text">{{inner.organiserNickname}}的团 只差<span class="text-num">{{inner.remainPersonNum}}</span>人</span>
                                        <span class="desc-countdown">距结束仅剩 {{inner.remainTimeFormat}}</span>
                                    </div>
                                </div>
                                <div class="group-detail-right" @click="joinGroup(inner.groupId)">去参团</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <groupListPopup :groupList="pendingList" :show.sync="showGroupListPopup"></groupListPopup>
    </div>
</template>

<script>
    // import _ from 'lodash';
    import groupListPopup from './groupListPopup';
    import formatTime from './formatTime';
    import { getPendingGroupListP } from 'create-api';
    import { Swipe, SwipeItem } from '@/components/detail/swipe/index';

    const DETAIL_REQUEST_NUM = 10;
    const DETAIL_SHOW_NUM = 2;
    const REQUEST_INTERVAL = 30000;
    const HEAD_IMAGE_DEFAULT =
        'https://m.tuniucdn.com/fb2/t1/G1/M00/78/90/Cii9EVidLHOIflFrAAARPEd3gL8AAHaVgNy3rgAABFU217_w60_h60_c1_t0.png';
    export default {
        name: 'groupList',
        props: {
            groupActivity: {
                type: Object,
                default: () => ({})
            },
            supportGroupBuying: {
                type: Boolean,
                default: false
            },
            status: {
                type: Number,
                default: 0
            }
        },

        components: {
            'swipe': Swipe,
            'swipe-item': SwipeItem,
            groupListPopup
        },

        data() {
            return {
                showGroupList: false,
                groupingPersonNum: 0,
                showGroupListPopup: false,
                pendingList: [],
                pendingListShow: [],
                countdownInterval: null,
                requestInterval: null,
                swiperHeight: '136px'

            }
        },

        mounted() {
            if (this.supportGroupBuying && this.status === 1) {
                this.getPendingGroupList();
                if (this.requestInterval) {
                    clearInterval(this.requestInterval);
                }
                this.requestInterval = setInterval(() => {
                    this.getPendingGroupList();
                }, REQUEST_INTERVAL)
            }
        },

        beforeDestroy() {
            if (this.countdownInterval) {
                clearInterval(this.countdownInterval);
            }
            if (this.requestInterval) {
                clearInterval(this.requestInterval);
            }
        },

        methods: {
            showMore() {
                this.showGroupListPopup = true;
            },
            joinGroup(groupId) {
                let url = `${window.location.origin}/wap-groupon/group/detail/${groupId}`;
                window.location.href = url;
            },
            async getPendingGroupList() {
                let res = await getPendingGroupListP({
                    activityId: this.groupActivity.retailPsId,
                    limit: DETAIL_REQUEST_NUM
                })
                if (res && res.success && res.data && res.data.pendinglist && res.data.pendinglist.length > 0) {
                    this.showGroupList = true;
                    this.groupingPersonNum = res.data.totalCnt;
                    res.data.pendinglist.forEach(val => {
                        if (val.organiserNickname.length > 4) {
                            val.organiserNickname = `${val.organiserNickname.substring(0, 4)}...`;
                        }
                        if (!val.organiserHeadImg) {
                            val.organiserHeadImg = HEAD_IMAGE_DEFAULT;
                        } else if (!val.organiserHeadImg.includes('https')) {
                            val.organiserHeadImg = val.organiserHeadImg.replace('http', 'https');
                        }
                        val.remainTimeFormat = '';
                    })
                    if (res.data.pendinglist.length > DETAIL_SHOW_NUM) {
                        let arr = [];
                        if (res.data.pendinglist.length % DETAIL_SHOW_NUM === 0) {
                            arr = res.data.pendinglist
                        } else {
                            for (let i = 0; i < DETAIL_SHOW_NUM; i++) {
                                arr.push(...res.data.pendinglist)
                            }
                        }
                        this.pendingListShow = _.chunk(arr, DETAIL_SHOW_NUM)
                        this.swiperHeight = 57 * DETAIL_SHOW_NUM + 'px';
                    } else {
                        this.pendingListShow = [res.data.pendinglist]
                        this.swiperHeight = 57 * res.data.pendinglist.length + 'px';
                    }
                    this.pendingList = res.data.pendinglist;
                    this.startCountDown();
                } else {
                    this.showGroupList = false;
                }
            },

            startCountDown() {
                if (this.countdownInterval) {
                    clearInterval(this.countdownInterval);
                }
                if (this.pendingList.length > 0) {
                    this.countdownInterval = setInterval(() => {
                        this.pendingList.forEach(val => {
                            if (val.remainTime >= 0) {
                                let {
                                    hour,
                                    minute,
                                    second,
                                    tenthOfSecond
                                } = formatTime.formatTime(val.remainTime, false);
                                val.remainTimeFormat =
                                    `${hour}:${minute}:${second}.${tenthOfSecond}`;
                            } else {
                                clearInterval(this.countdownInterval);
                            }
                            val.remainTime -= 0.1;
                        });
                    }, 100)
                }
            }
        }
    }

</script>

<style lang="scss">
    .group-list-wrap {
        margin-top: 9px;
        border-radius: 18px;
        overflow: hidden;
        background: #fff;
        padding: 12px 0 9px;

        .group-list-head {
            height: 23px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 18px;

            &>div {
                display: flex;
                align-items: center;
                &:last-child {
                    position: relative;
                    left: 12px;
                }
            }

            .group-list-img {
                height: 14px;
                width: 14px;
            }

            .group-list-text {
                font-family: PingFangSC-Semibold;
                font-size: 14px;
                line-height: 14px;
                margin-left: 7px;
            }

            .text-num {
                color: #FF6436;
            }

            .text-desc {
                color: #1A1A1A;
            }

            .show-more {
                font-family: PingFang-SC-Regular;
                font-size: 13px;
                color: #A5A5A5;
                line-height: 14px;
            }

            .arrow-right {
                height: 24px;
                width: 24px;
            }
        }

        .group-list-body {
            .group-swiper {
                height: 136px;
            }

            .group-swiper-single {
                height: 57px;
            }

            .group-detail-wrap {
                height: 57px;
                padding: 0 18px;
                background: #FFF;

                .top-border {
                    border-top: 0.5px solid rgba(0, 0, 0, 0.1);
                }

                .group-detail {
                    height: 100%;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    .group-detail-left {
                        display: flex;

                        .detail-img {
                            width: 40px;
                            height: 40px;
                            border-radius: 50%;
                        }

                        .detail-desc {
                            margin-left: 9px;
                            display: flex;
                            flex-direction: column;
                            justify-content: space-around;

                            .desc-text {
                                font-family: PingFang-SC-Regular;
                                font-size: 14px;
                                color: #383838;
                                line-height: 14px;

                                .text-num {
                                    color: #FF6436;
                                }
                            }

                            .desc-countdown {
                                font-family: PingFang-SC-Regular;
                                font-size: 12px;
                                color: #777893;
                                line-height: 14px;
                            }
                        }
                    }

                    .group-detail-right {
                        height: 28px;
                        width: 64px;
                        border: 0.5px solid #FF6436;
                        border-radius: 15px;
                        font-family: PingFang-SC-Medium;
                        font-size: 13px;
                        color: #FF6436;
                        text-align: center;
                        line-height: 28px;
                    }
                }
            }
        }
    }

</style>



// WEBPACK FOOTER //
// groupList.vue